<template>
  <details v-if="scopes.length" class="lynda-data-scope">
    <summary>Data loaded for this chat · {{ scopes.length }} {{ scopes.length === 1 ? 'snapshot' : 'snapshots' }}</summary>
    <p class="lynda-data-note">Available when this answer was written. The answer explains which data it uses.</p>
    <ul tabindex="0" aria-label="Loaded dataset details">
      <li v-for="(entry, index) in scopes" :key="index">
        <strong>{{ entry.dataset === 'clip_events' ? 'Clip engagement' : 'Survey responses' }}</strong>
        <span>Universities: {{ (entry.scope.universitySlugs || [entry.scope.universitySlug]).join(', ') }}</span>
        <span>{{ ceremonies(entry) }}</span>
        <span>{{ entry.dataset === 'clip_events' ? 'Event window' : 'Ceremony dates' }}: {{ windowLabel(entry) }}</span>
        <span v-if="entry.dataset === 'survey_answers'">{{ entry.scope.surveyVersion || 'All survey versions' }}</span>
        <span>Loaded {{ date(entry.extracted_at) }}</span>
      </li>
    </ul>
  </details>
</template>
<script>
export default {
  name: 'LyndaDataScope',
  props: { scopes: { type: Array, default: () => [] } },
  methods: {
    date(value) {
      if (!value) return 'Unknown'
      const parsed = new Date(value)
      return Number.isNaN(parsed.getTime()) ? 'Unknown' : parsed.toLocaleString('en-GB', { timeZone: 'UTC', timeZoneName: 'short' })
    },
    ceremonies(entry) {
      if (entry.ceremony_count != null) return `${entry.ceremony_count} ceremonies in this scope`
      if (entry.ceremonies?.length) return entry.ceremonies.map(c => {
        const label = `${entry.scope?.universitySlugs?.length > 1 ? c.university_slug + ': ' : ''}${c.label || c.id}`
        return c.date ? `${label} (${this.date(c.date)})` : label
      }).join('; ')
      const ids = entry.scope?.ceremonyIds
      return ids === null ? 'All ceremonies in this scope' : ids?.length ? ids.join(', ') : 'No ceremonies selected'
    },
    windowLabel(entry) {
      const window = entry.date_window || {}
      if (!window.start && !window.end) return 'No date filter'
      return `${window.start ? this.date(window.start) : 'No start limit'} – ${window.end ? this.date(window.end) : 'No end limit'}`
    },
  },
}
</script>
